import parsePhoneNumber from 'libphonenumber-js';
interface CleanPhoneNumber {
	(number: string): string;
}

const cleanPhoneNumber: CleanPhoneNumber = number => {
	const phoneNumber = parsePhoneNumber(`+${number.replace(/^\+/, '')}`);
	return phoneNumber
		? `${phoneNumber.countryCallingCode}${phoneNumber.nationalNumber}`
		: number.replace(/[^0-9]/g, '');
};

export default cleanPhoneNumber;
